import PropTypes from "prop-types";
import { useState } from "react";

import AttachmentsButton from "./attachmentsButton";
import AttachmentsModal from "./attachmentsModal";

const ViewAttachments = ({ attachments, title, toolTipText }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <AttachmentsButton setOpen={setOpen} toolTipText={toolTipText} />
            <AttachmentsModal
                attachments={attachments}
                open={open}
                setOpen={setOpen}
                title={title}
            />
        </>
    );
};
ViewAttachments.propTypes = {
    attachments: PropTypes.array,
    title: PropTypes.string,
    toolTipText: PropTypes.string,
};
export default ViewAttachments;
